/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attach_Next_ImageInputs */

const vi_attach_next_image = /** @type {(inputs: Attach_Next_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh sau`)
};

/**

* @param {Attach_Next_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const attach_next_image = /** @type {((inputs?: Attach_Next_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attach_Next_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_attach_next_image(inputs)
});